<template>
  <v-dialog
    v-model="show"
    width="400px">
    <div class="dialog-container">
      <div class="dialog-header">
        <p>{{title}}</p>
        <font-awesome-icon
          icon="times"
          class="pointer"
          @click="changeDialog"></font-awesome-icon>
      </div>
      <div class="dialog-body">
        <el-form
          ref="form"
          :model="form"
          :rules="rules">
          <div class="form-item">
            <span>Are you sure to update all{{num>0?`(${num})`:''}} status? </span>
            <el-form-item prop="status">
              <v-radio-group
                v-model="form.status"
                :list="statusList"
              >
                <template
                  #default="{ item }"
                  name="input">
                  <span class="flex-sb-center">
                    <span
                      class="circle"
                      :class="{
                        'yellow': item.id == 0,
                        'red': item.id == 2,
                        'green': item.id == 1,
                      }"></span>
                    <span>{{ item['name'] }}</span>
                  </span>
                </template>
              </v-radio-group>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class="dialog-footer">
        <div class="btn">
          <div class="lef">
            <v-button
              gray
              @click="handleCancel">Cancel</v-button>
          </div>
          <div class="right">
            <v-button
              green
              @click="handleSave">Update</v-button>
          </div>
        </div>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import {updateHanbergStatus} from '@/api/hanberg'
import {updateHzmbStatus} from '@/api/hzmb'
import MixinOptions from '@/mixins/options'

export default {
  name: 'exclusiveUpdateDialog',
  mixins: [MixinOptions],
  props:{
    selectArr: {
      type: Array,
      default: () => []
    },
    value:{
      type: Boolean,
      default: false
    },
    isHzmb:{
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      show: false,
      form:{
        status: '',
      },
      rules:{
        status: [
          { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
      },
      timer: null,
    }
  },
  computed:{
    title(){
      return 'Update Status'
    },
    statusList(){
      let {hanberg_status} = this.globalOptions||{}
      return hanberg_status||[]
    },
    num(){
      return this.selectArr.length
    }
  },
  watch:{
    value:{
      immediate: true,
      deep: true,
      handler(val){
        this.show = val||false
      }
    },
  },
  methods: {
    changeDialog(){
      this.show = !this.show
    },

    handleCancel(){
      this.$emit('input',false)
    },
    handleSave(){
      this.$refs['form'].validate(valid => {
        if(valid){
          if(this.isHzmb){
            this.network().updateHzmbStatus()
          }
          else
            this.network().updateHanbergStatus()
        }
      })
    },

    network(){
      return {
        updateHanbergStatus: async (params) => {
          if(this.selectArr.length<=0)
            return  this.$message('請選擇')
          let {data} = await updateHanbergStatus({
            id_arr:this.selectArr,
            status:this.form.status
          })
          this.$emit('input',false)
          this.$emit('update')
        },
        updateHzmbStatus: async (params) => {
          if(this.selectArr.length<=0)
            return  this.$message('請選擇')
          let {data} = await updateHzmbStatus({
            id_arr:this.selectArr,
            status:this.form.status
          })
          this.$emit('input',false)
          this.$emit('update')
        },
      }
    }
  },
}
</script>
<style lang='scss' scoped>
.dialog-container{
  .dialog-header{
    height: 20px;
    padding: 16px;
    box-sizing: content-box;
    display: flex;
    justify-content: space-between;
    background: #F6F8FA;
    border: 1px solid #E1E4E8;
    border-radius: 6px 6px 0px 0px;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    color: #1B1F23;
  }
  .dialog-body{
    padding: 20px 15px 0 15px;
    .el-form{
      .form-item:last-child{
        padding-bottom: 0;
      }
    }
  }
  .dialog-footer{
    padding: 20px 15px 15px 15px;
    .btn{
      display: flex;
      justify-content: space-between;
      .red{
        color: #CB2431;
      }
    }
  }
  .circle {
    display: inline-block;
    margin-right: 5px;
    width: 14px;
    height: 14px;
    min-width: 14px;
    min-height: 14px;
    border-radius: 100%;
    &.yellow {
      background: #E36209;
    }
    &.green {
      background: #28A745;
    }
    &.red {
      background: #D73A49;
    }
  }
}
/deep/ .el-radio{
  display: flex;
  align-items: center;
  margin-bottom: 5px;
}
</style>
